import { Text, VStack } from '@chakra-ui/react'
import { ReactNode } from 'react'

export const NavGroup = ({ label, children }: { label: string; children: ReactNode }) => (
  <VStack align={'stretch'} gap={1}>
    <Text color={'colorPalette.fg/40'} paddingX={3} textStyle={'labelXs'}>
      {label}
    </Text>
    {children}
  </VStack>
)
